import React, { useState, useEffect } from "react";

import { endPoints } from "../../../constant/Environment";
import { addData, getAllData } from "../../../Utility/API";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  IconButton,
  TablePagination,
} from "@mui/material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import moment from "moment-timezone";
import { useTheme } from "@mui/material/styles";

import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import { tokens } from "../../../theme";
import { mono, pill, statusKind, th, td, filterFieldSx, ConfirmDialog } from "./uiKit";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
    </Box>
  );
}

const StatusTypeList = [
  { id: "0", name: "All" },
  { id: "1", name: "Pending" },
  { id: "2", name: "Processed" },
  { id: "3", name: "Canceled" },
];

const statusLabel = (s) => (s == 2 ? "Processed" : s == 1 ? "Pending" : s == 3 ? "Canceled" : "");
const fmtDate = (d) => (d && moment.utc(d).isValid() ? moment.utc(d).format("YYYY-MM-DD") : "");

const RedemDetails = (props) => {
  const { selectedRecord } = props;

  const [viewShow, setViewShow] = useState(false);
  const [checkShow, setCheckShow] = useState(false);
  const [cancelShow, setCancelShow] = useState(false);

  const [editData, setEditData] = useState({});
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [statusType, setStatusType] = useState("0");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    redemptionClaimById(selectedRecord.user_id);
  }, [selectedRecord]);

  const redemptionClaimById = async (id) => {
    let url = `${endPoints.api.GET_REDEMPTIONCLAIM}/${id}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response?.status === "success") {
          setRows(response.data);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const approveRedeem = () => {
    let url = editData?.id ? `${endPoints.api.UPDATE_REDEMPTIONCLAIM}` : null;

    let payload = {
      tracking_number: "",
      status: "2",
      processed_date: "",
      giftcopy: "",
      terms_condition: "",
    };

    if (editData?.id) {
      payload.id = editData.id;
    }
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          redemptionClaimById(selectedRecord.user_id);
          setCheckShow(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  const cancelRedeem = () => {
    let url = editData?.id ? `${endPoints.api.UPDATE_REDEMPTIONCLAIM}` : null;

    let payload = {
      tracking_number: editData?.tracking_number,
      status: "3",
      processed_date: editData?.processed_date,
      giftcopy: editData?.giftcopy,
      terms_condition: editData?.terms_condition,
    };

    if (editData?.id) {
      payload.id = editData.id;
    }
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          redemptionClaimById(selectedRecord.user_id);
          setCancelShow(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  const rowsToDisplay =
    statusType === "0" ? rows : rows.filter((item) => item.status?.includes(statusType));

  const claimFacts = (d) => [
    ["Gift Title", d?.gift_title],
    ["Tracking No", d?.tracking_number],
    ["Customer ID", d?.user_id],
    ["Transaction ID", d?.transaction_id],
    ["Saga Price", d?.sagacoin_price != null ? `$${d.sagacoin_price}` : "—"],
    ["Processed Date", fmtDate(d?.processed_date) || "—"],
  ];

  return (
    <Box>
      <Toaster></Toaster>
      {isLoading && <Loader spinner={true} visible={isLoading} />}

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, alignItems: "center", mb: 2 }}>
        <TextField
          select
          size="small"
          label="Status"
          value={statusType}
          onChange={(e) => {
            setStatusType(e.target.value);
            setPage(0);
          }}
          sx={filterFieldSx}
        >
          {StatusTypeList.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {item.name}
            </MenuItem>
          ))}
        </TextField>
      </Box>

      <Box sx={{ overflowX: "auto" }}>
        <Box component="table" sx={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={th}>Player</th>
              <th style={th}>Gift</th>
              <th style={th}>Account</th>
              <th style={th}>Requested</th>
              <th style={th}>Processed</th>
              <th style={th}>Status</th>
              <th style={th}>Price</th>
              <th style={th}>Decision</th>
            </tr>
          </thead>
          <tbody>
            {rowsToDisplay.length === 0 && !isLoading && (
              <tr>
                <td colSpan={8} style={{ ...td, textAlign: "center", color: tokens.textDim }}>
                  No redemption claims found
                </td>
              </tr>
            )}
            {rowsToDisplay
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <tr key={row.id}>
                  <td style={td}>
                    <div style={{ fontWeight: 600 }}>{row.name}</div>
                    <div style={{ fontFamily: mono, fontSize: 10.5, color: tokens.textDim2 }}>
                      #{row.user_id} · {row.email}
                    </div>
                  </td>
                  <td style={td}>
                    <div style={{ fontWeight: 600 }}>{row.gift_title}</div>
                    {row.pin && (
                      <div style={{ fontFamily: mono, fontSize: 10.5, color: tokens.textDim2 }}>{row.pin}</div>
                    )}
                  </td>
                  <td style={td}>{row.accountStatus ? pill(row.accountStatus, statusKind(row.accountStatus)) : ""}</td>
                  <td style={{ ...td, fontFamily: mono, color: tokens.textDim }}>{fmtDate(row.created_on)}</td>
                  <td style={{ ...td, fontFamily: mono, color: tokens.textDim }}>{fmtDate(row.processed_date)}</td>
                  <td style={td}>{statusLabel(row.status) ? pill(statusLabel(row.status), statusKind(statusLabel(row.status))) : ""}</td>
                  <td style={{ ...td, fontFamily: mono, fontWeight: 700 }}>${row.sagacoin_price}</td>
                  <td style={td}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Button
                        size="small"
                        variant="outlined"
                        color="inherit"
                        sx={{ textTransform: "none", color: tokens.textDim, borderColor: tokens.border }}
                        onClick={() => {
                          setViewShow(true);
                          setEditData(row);
                        }}
                      >
                        View
                      </Button>
                      {row.status == 1 && (
                        <>
                          <Button
                            size="small"
                            variant="outlined"
                            sx={{ textTransform: "none", color: tokens.secondary, borderColor: "rgba(35,214,160,0.4)" }}
                            onClick={() => {
                              setCheckShow(true);
                              setEditData(row);
                            }}
                          >
                            Approve
                          </Button>
                          <Button
                            size="small"
                            variant="outlined"
                            sx={{ textTransform: "none", color: tokens.danger, borderColor: "rgba(242,92,102,0.4)" }}
                            onClick={() => {
                              setCancelShow(true);
                              setEditData(row);
                            }}
                          >
                            Cancel
                          </Button>
                        </>
                      )}
                    </Box>
                  </td>
                </tr>
              ))}
          </tbody>
        </Box>
      </Box>

      <TablePagination
        component="div"
        rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
        count={rowsToDisplay.length}
        rowsPerPage={rowsPerPage}
        page={page}
        SelectProps={{
          inputProps: { "aria-label": "rows per page" },
          native: true,
        }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        ActionsComponent={TablePaginationActions}
        sx={{ borderTop: `1px solid ${tokens.border}`, mt: 1 }}
      />

      <ConfirmDialog
        open={viewShow}
        onClose={() => setViewShow(false)}
        title="Redemption Details"
        facts={claimFacts(editData)}
      />

      <ConfirmDialog
        open={checkShow}
        onClose={() => setCheckShow(false)}
        title="Redemption Approval"
        facts={claimFacts(editData)}
        question="Would you like to approve this redemption?"
        note="After approval, funds will be sent to the payment provider."
        actionLabel="Approve Redemption"
        actionColor={tokens.secondary}
        onAction={approveRedeem}
      />

      <ConfirmDialog
        open={cancelShow}
        onClose={() => setCancelShow(false)}
        title="Redemption Cancellation"
        facts={claimFacts(editData)}
        question="Would you like to cancel this redemption?"
        actionLabel="Cancel Request"
        actionColor={tokens.danger}
        onAction={cancelRedeem}
      />
    </Box>
  );
};

export default RedemDetails;
